import { useTranslation } from 'react-i18next';
import { IsoStringDatePicker } from "./IsoStringDatePicker";

export function IsoStartEndDatePicker({
    startIsoDate,
    endIsoDate,
    handleStartDateChange,
    handleEndDateChange,
    timezone,
    dateOnly,
    maxDate = undefined,
    compact = false,
    startText,
    endText,
}) {

    const { t } = useTranslation();

    return (
        <div className={`
            ${compact ? "" : "flex-grow-1"}
            d-flex
            ${compact ? "" : "justify-content-between"}
            align-items-center
        `}>
            {datePicker(
                startText ?? t("common.from"),
                startIsoDate,
                handleStartDateChange,
                IsoStringDatePicker.popperPlacementOptions().bottom,
            )}
            <div className="ml-2"/>
            {datePicker(
                endText ?? t("common.to"),
                endIsoDate,
                handleEndDateChange,
                IsoStringDatePicker.popperPlacementOptions().bottom,
            )}
        </div>
    );

    function datePicker(
        name,
        isoDate,
        handleDateChange,
        popperPlacement,
    ) {
        return (
            <div className={compact ? "" : "full-width-datepicker"}>
                <IsoStringDatePicker
                text={name}
                placeholderText={name}
                isoString={isoDate}
                popperPlacement={popperPlacement}
                timezone={timezone}
                onChange={handleDateChange}
                dateOnly={dateOnly}
                maxDate={maxDate}
                compact={compact}
            />
            </div>
        );
    }
}